import { LifeBuoy } from 'lucide-react';
import type { NavModule } from '../../lib/navigation';

export const supportNav: NavModule = {
  id: 'support',
  label: 'Support',
  icon: LifeBuoy,
  capability: { domain: 'support', action: 'read' },
  children: [
    { id: 'support-l2', label: 'L2 Dashboard', path: '/support/l2' },
    { id: 'support-l3', label: 'L3 Dashboard', path: '/support/l3' },
  ],
};
